import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircleHeart, Star } from 'lucide-react';
const chatImages = ['https://cdn.magicpatterns.com/uploads/7dTT5D5oCDBg1Sw6HaZeoC/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/25gdn1ZfjeiYcCaDD8rGyk/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/f7RNmfj4cqZgvy96QE85yJ/pasted-image.jpg', 'https://cdn.magicpatterns.com/uploads/x2t4jkY7J58w5QwY4YWqW9/pasted-image.jpg', 'https://cdn.magicpatterns.com/uploads/hwgRBwWo4rUebUxVwzbfBm/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/3QnKHSF1XjcogvHFfcRpiE/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/vK1fLXoR8UUZtngLi3Agjk/pasted-image.png', 'https://cdn.magicpatterns.com/uploads/ad3tF3YbBBTbQfv2gQDC2L/pasted-image.png'];
const liveCards = ['https://cdn.magicpatterns.com/uploads/12VX5HHC6M7kV9NsNDHwM9/image.png', 'https://cdn.magicpatterns.com/uploads/9mVDGGJSsGYsx7rGCwSotJ/image.png', 'https://cdn.magicpatterns.com/uploads/588VBS3dBL8FU4rwS3kF9p/image.png', 'https://cdn.magicpatterns.com/uploads/8Pb3n8LJWsKA5SpjUQN6B3/image.png', 'https://cdn.magicpatterns.com/uploads/ktMqaQnSFuw7Y6w5opYZdy/image.png'];
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % liveCards.length);
    }, 3500);
    return () => clearInterval(timer);
  }, []);
  return <section className="px-6 py-10 flex flex-col items-center text-center max-w-7xl mx-auto" data-id="element-405">
      <div className="w-full max-w-6xl relative rounded-[3rem] p-[2px] bg-gradient-to-b from-[#D98BAF]/80 via-brand-navy to-brand-navy shadow-[0_25px_60px_-15px_rgba(217,139,175,0.35)]" data-id="element-406">
        <div className="bg-brand-navy rounded-[2.9rem] px-6 py-10 md:px-12 md:py-12 relative overflow-hidden flex flex-col items-center" data-id="element-407">
          {/* Ambient glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-[#D98BAF]/15 blur-[140px] rounded-full pointer-events-none" data-id="element-408" />

          <div className="inline-flex items-center gap-2 bg-[#D98BAF]/15 border border-[#D98BAF]/40 text-[#D98BAF] font-bold text-[11px] md:text-sm uppercase tracking-[0.2em] px-6 py-2.5 rounded-full mb-8 backdrop-blur-sm relative z-10" data-id="element-409">
            <MessageCircleHeart size={16} strokeWidth={2.5} data-id="element-410" />
            Casos de éxito
          </div>

          <h2 className="neon-title font-black text-[36px] md:text-[60px] leading-[1.05] tracking-tight uppercase mb-6 max-w-4xl relative z-10" style={{
          fontFamily: "'Inter', sans-serif",
          fontWeight: 900
        }} data-id="element-411">
            Lo que dicen mis{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D98BAF] to-[#fce7f1]" data-id="element-412">
              alumnas
            </span>
          </h2>

          <div className="flex items-center gap-2 mb-16 relative z-10" data-id="element-413">
            <div className="flex gap-1" data-id="element-414">
              {[...Array(5)].map((_, i) => <Star key={i} size={20} className="text-[#D4AF37] fill-[#D4AF37]" data-id="element-415" />)}
            </div>
            <span className="text-white/80 font-medium text-lg" data-id="element-416">
              +3.500 vidas transformadas
            </span>
          </div>

          {/* Live Testimonial Card Carousel */}
          <div className="w-full max-w-3xl relative aspect-[1.8/1] flex items-center justify-center mb-20 z-10" data-id="element-417">
            <div className="absolute -inset-6 bg-gradient-to-tr from-[#D98BAF]/30 via-brand-lavender/20 to-[#D98BAF]/30 rounded-[2rem] blur-2xl opacity-60" data-id="element-418"></div>
            <div className="relative w-full h-full rounded-[1.5rem] overflow-hidden border border-[#D98BAF]/40 shadow-[0_0_50px_rgba(217,139,175,0.3)] bg-black/50" data-id="element-419">
              <AnimatePresence mode="wait" data-id="element-420">
                <motion.img key={currentIndex} src={liveCards[currentIndex]} initial={{
                opacity: 0,
                scale: 0.95
              }} animate={{
                opacity: 1,
                scale: 1
              }} exit={{
                opacity: 0,
                scale: 1.05
              }} transition={{
                duration: 0.6,
                ease: 'easeInOut'
              }} className="w-full h-full object-contain absolute inset-0" alt="Testimonio destacado" data-id="element-421" />
              </AnimatePresence>
            </div>

            {/* Carousel Indicators */}
            <div className="absolute -bottom-8 left-1/2 -translate-x-1/2 flex gap-2" data-id="element-422">
              {liveCards.map((_, i) => <div key={i} className={`h-1.5 rounded-full transition-all duration-500 ${i === currentIndex ? 'w-8 bg-[#D98BAF] shadow-[0_0_10px_rgba(217,139,175,0.8)]' : 'w-2 bg-white/20'}`} data-id="element-423" />)}
            </div>
          </div>

          <h3 className="font-serif font-bold text-2xl md:text-3xl text-white mb-10 relative z-10" data-id="element-424">
            Más resultados reales 👇🏻
          </h3>

          {/* Chat Screenshots Grid */}
          <div className="w-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 relative z-10" data-id="element-425">
            {chatImages.map((src, i) => <motion.div key={i} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.05
          }} className="rounded-2xl overflow-hidden border border-white/10 shadow-lg hover:shadow-[0_0_25px_rgba(217,139,175,0.3)] hover:border-[#D98BAF]/40 transition-all group bg-white/5" data-id="element-426">
                <img src={src} alt={`Testimonio chat ${i + 1}`} className="w-full h-auto block object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-427" />
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}